import moment from "moment-timezone";

const timeIsValid = (time) => moment(time, "HH:mm:ss", true).isValid();

const FormattedDuration = ({ timeRange }) => {
  const [startTimeStr, endTimeStr, timezone] = timeRange
    .split("-")
    .map((s) => s.trim());

  const validDate = timeIsValid(startTimeStr) && timeIsValid(endTimeStr);
  if (!validDate || !moment.tz.zone(timezone)) {
    return "Unknown";
  }

  const today = moment().format("YYYY-MM-DD");
  const start = moment.tz(`${today}T${startTimeStr}`, timezone);
  const end = moment.tz(`${today}T${endTimeStr}`, timezone);

  const durationMs = end.diff(start);
  const duration = moment.utc(durationMs).format("HH:mm");

  return <span>{duration}</span>;
};

export default FormattedDuration;
